$(document).ready(function() {

    $('.open_calculator').click(function(event) {
        $('#leasing_calc').css('display', 'block').animate({
            width: '100%'
        }, 400, function() {
            toCountHRV();
            toCountStandart();
        });

        if ($(window).width() > 992) {
            var calculatorContainer = $('.calculator_container').outerHeight();
            $('.bg_desk_black').css('min-height', calculatorContainer + 'px');
        }
        if ($(window).width() < 1199 && $(window).width() > 991) {
            var calculatorContainer = $('.calculator_container').outerHeight();
            $('.bg_desk_black').css('min-height', calculatorContainer + 50 + 'px');
        }
        if ($(window).width() < 991) {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        }
    });

    $('.close_calculator').click(function(event) {
        $('#leasing_calc').animate({
            width: '0'
        }, 400, function() {
            $(this).css('display', 'none');
        });
    });

    var changeCalc = $('.change_calculate .btn_change_calc');

    changeCalc.click(function(event) {
        $('.btn_change_calc').removeClass('active');
        $(this).addClass('active');
        if (changeCalc.hasClass('active')) {
            $('.calculator').removeClass('open')
            $('#' + $(this).attr('rel')).addClass('open');
        }
        toCountHRV();
        toCountStandart();
        toCountCredit();
        toCountLoan();
    });

    function getMonthlyPaymentCredit(result, rateResult, table, months, downPayment) {
        let downPaymentIndex = downPayment / 5;
        let cell = table[months][downPaymentIndex];
        let [price, rate] = cell.split(", ");

        result.text(price);
        rateResult.text(rate);
    }


    function getMonthlyPayment(result, table, months, downPayment) {
        let downPaymentIndex = downPayment / 5;
        let monthlyPayment = table[months][downPaymentIndex];
        result.text(monthlyPayment);
    }

    /**
     * Baicowy leasing
     */
    function toCountHRV() {
        var pathName = window.location.pathname;
        if ($('#calculateRateHRV').hasClass('open')) {
            var result = $('#monthlyPaymentHRV');

            if (pathName.includes('baic-7')) {
                var leasingHRVTable = {
                    '24': ["2 684", "2 377", "2 070", "1 764", "1 457", "1 151", "843"],
                    '36': ["2 220", "1 986", "1 772", "1 558", "1 345", "1 132", "918"],
                    '48': ["1 996", "1 829", "1 661", "1 495", "1 327", "1 160", "993"],
                    '60': ["2 113", "1 974", "1 834", "1 694", "1 554", "1 415", "1 275"]
                };

            }
            if (pathName.includes('baic-5')) {
                var leasingHRVTable = {
                    '24': ["2 113", "1 872", "1 630", "1 389", "1 147", "906", "664"],
                    '36': ["1 732", "1 564", "1 395", "1 227", "1 059", "891", "723"],
                    '48': ["1 572", "1 440", "1 308", "1 177", "1 045", "913", "782"],
                    '60': ["1 664", "1 554", "1 444", "1 334", "1 224", "1 114", "1 004"]
                };

            }
            if (pathName.includes('baic-3')) {
                var leasingHRVTable = {
                    '24': ["1 541", "1 383", "1 225", "1 067", "909", "751", "593"],
                    '36': ["1 243", "1 134", "1 024", "914", "804", "694", "584"],
                    '48': ["1 115", "1 019", "943", "857", "770", "664", "598"],
                    '60': ["1 161", "1 089", "1 017", "945", "873", "802", "729"]
                };

            }



            $('#monthsHRV').on('input', function() {
                $('#monthsHRVValue').text($(this).val());
                getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
                const monthsValue = $('#monthsHRV').val();
                const kmLimits = {
                    "24": "50 000 KM",
                    "36": "75 000 KM",
                    "48": "100 000 KM",
                    "60": "100 000 KM"
                };

                if (pathName.includes('baic-3')) {
                    var priceGapTable = {
                        "24": "1220",
                        "36": "1220",
                        "48": "1680",
                        "60": "2170"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var priceGapTable = {
                        "24": "1500",
                        "36": "1500",
                        "48": "2015",
                        "60": "2480"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var priceGapTable = {
                        "24": "1860",
                        "36": "1860",
                        "48": "2560",
                        "60": "2900"
                    };
                }

                if (kmLimits.hasOwnProperty(monthsValue)) {
                    $('#kmLimitHRVValue').text(kmLimits[monthsValue]);
                }

                if (priceGapTable.hasOwnProperty(monthsValue)) {
                    $('#priceGap').text(priceGapTable[monthsValue]);
                }

            });
            $('#downPaymentHRV').on('input', function() {
                $('#downPaymentHRVValue').text($(this).val() + '%');
                getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
            });
            getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
        }
    }

    /**
     * Leasing standard
     */
    function toCountStandart() {
        var pathName = window.location.pathname;
        if ($('#calculateRateStandart').hasClass('open')) {
            var result = $('#monthlyPaymentStandart');

            if (pathName.includes('baic-7')) {
                var leasingStandartTable = {
                    "24": ["5 142", "4 834", "4 526", "4 220", "3 913", "3 607", "3 299"],
                    "30": ["4 632", "4 382", "4 131", "3 880", "3 630", "3 379", "3 128"],
                    "36": ["4 152", "3 938", "3 725", "3 512", "3 298", "3 085", "2 871"],
                    "42": ["3 636", "3 449", "3 263", "3 076", "2 888", "2 703", "2 515"],
                    "48": ["3 252", "3 086", "2 918", "2 751", "2 584", "2 417", "2 249"],
                    "54": ["2 953", "2 800", "2 649", "2 498", "2 346", "2 195", "2 042"],
                    "60": ["2 715", "2 577", "2 437", "2 297", "2 158", "2 018", "1 878"]
                };

            }
            if (pathName.includes('baic-5')) {
                var leasingStandartTable = {
                    "24": ["4 049", "3 806", "3 564", "3 323", "3 081", "2 840", "2 598"],
                    "30": ["3 647", "3 450", "3 253", "3 055", "2 858", "2 661", "2 463"],
                    "36": ["3 269", "3 101", "2 933", "2 765", "2 597", "2 429", "2 261"],
                    "42": ["2 863", "2 716", "2 569", "2 422", "2 274", "2 128", "1 980"],
                    "48": ["2 561", "2 430", "2 298", "2 166", "2 035", "1 903", "1 771"],
                    "54": ["2 325", "2 205", "2 086", "1 967", "1 847", "1 728", "1 608"],
                    "60": ["2 138", "2 029", "1 919", "1 809", "1 699", "1 589", "1 479"]
                };


            }
            if (pathName.includes('baic-3')) {
                var leasingStandartTable = {
                    "24": ["2 804", "2 646", "2 488", "2 331", "2 173", "2 015", "1 857"],
                    "30": ["2 515", "2 386", "2 257", "2 128", "1 999", "1 870", "1 741"],
                    "36": ["2 248", "2 138", "2 028", "1 918", "1 808", "1 698", "1 588"],
                    "42": ["1 969", "1 873", "1 777", "1 631", "1 584", "1 488", "1 392"],
                    "48": ["1 781", "1 675", "1 589", "1 503", "1 417", "1 331", "1 245"],
                    "54": ["1 600", "1 521", "1 443", "1 365", "1 287", "1 209", "1 130"],
                    "60": ["1 471", "1 399", "1 327", "1 255", "1 183", "1 111", "1 040"]
                };
            }

            $('#monthsStandart').on('input', function() {
                $('#monthsStandartValue').text($(this).val());
                getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
                const buyOutCost = {
                    "24": "17%",
                    "30": "7%",
                    "36": "1%",
                    "42": "1%",
                    "48": "1%",
                    "54": "1%",
                    "60": "1%"
                };
                const monthsValue = $('#monthsStandart').val();
                if (buyOutCost.hasOwnProperty(monthsValue)) {
                    $('#buyOut').text(buyOutCost[monthsValue]);
                }

                if (pathName.includes('baic-3')) {
                    var gapTableStandart = {
                        "24": "1220",
                        "30": "1220",
                        "36": "1220",
                        "42": "1680",
                        "48": "1680",
                        "54": "2170",
                        "60": "2170"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var gapTableStandart = {
                        "24": "1500",
                        "30": "1500",
                        "36": "1500",
                        "42": "2015",
                        "48": "2015",
                        "54": "2480",
                        "60": "2480"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var gapTableStandart = {
                        "24": "1860",
                        "30": "1860",
                        "36": "1860",
                        "42": "2560",
                        "48": "2560",
                        "54": "2900",
                        "60": "2900"
                    };
                }
                if (gapTableStandart.hasOwnProperty(monthsValue)) {
                    $('#priceGapStandart').text(gapTableStandart[monthsValue]);
                }

            });
            $('#downPaymentStandart').on('input', function() {
                $('#downPaymentStandartValue').text($(this).val() + '%');
                getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
            });
            getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
        }
    }


    /**
     * Baicowa pożyczka
     */
    function toCountCredit() {
        var pathName = window.location.pathname;
        if ($('#calculateRateCredit').hasClass('open')) {
            var result = $('#monthlyPaymentCredit');
            var rateResult = $('#monthlyRRSOCredit');


            if (pathName.includes('baic-7')) {
                var CreditTable = {

                    24: ["4 600 , 12,97", "4 190 , 12,91", "3 779 , 12,85", "3 369 , 12,78", "2 959 , 12,70", "2 549 , 12,62", "2 139 , 12,53"],
                    36: ["3 823 , 12,45", "3 540 , 12,42", "3 257 , 12,38", "2 975 , 12,34", "2 692 , 12,30", "2 409 , 12,25", "2 126 , 12,20"],
                    48: ["3 243 , 11,85", "3 023 , 11,83", "2 803 , 11,81", "2 584 , 11,78", "2 364 , 11,75", "2 144 , 11,72", "1 924 , 11,69"],
                    60: ["3 001 , 11,56", "2 818 , 11,55", "2 636 , 11,54", "2 453 , 11,52", "2 271 , 11,51", "2 088 , 11,49", "1 906 , 11,47"]

                };
            }
            if (pathName.includes('baic-5')) {
                var CreditTable = {

                    24: ["3 707 , 13,01", "3 377 , 12,95", "3 047 , 12,89", "2 716 , 12,82", "2 386 , 12,74", "2 056 , 12,66", "1 725 , 12,57"],
                    36: ["3 082 , 12,49", "2 854 , 12,46", "2 626 , 12,42", "2 398 , 12,38", "2 171 , 12,34", "1 943 , 12,30", "1 715 , 12,24"],
                    48: ["2 615 , 11,89", "2 438 , 11,87", "2 261 , 11,85", "2 084 , 11,83", "1 907 , 11,80", "1 730 , 11,77", "1 553 , 11,74"],
                    60: ["2 420 , 11,60", "2 273 , 11,59", "2 126 , 11,58", "1 979 , 11,57", "1 832 , 11,56", "1 685 , 11,54", "1 538 , 11,53"]

                };
            }
            if (pathName.includes('baic-3')) {
                var CreditTable = {

                    24: ["2 376 , 13,12", "2 164 , 13,06", "1 953 , 13,00", "1 742 , 12,94", "1 531 , 12,87", "1 320 , 12,79", "1 108 , 12,71"],
                    36: ["1 976 , 12,60", "1 830 , 12,57", "1 684 , 12,54", "1 539 , 12,51", "1 393 , 12,47", "1 248 , 12,43", "1 102 , 12,39"],
                    48: ["1 677 , 12,01", "1 564 , 11,99", "1 451 , 11,97", "1 337 , 11,95", "1 224 , 11,93", "1 111 , 11,91", "998 , 11,89"],
                    60: ["1 552 , 11,72", "1 458 , 11,71", "1 364 , 11,71", "1 270 , 11,70", "1 176 , 11,70", "1 082 , 11,69", "988 , 11,69"]

                };
            }

            $('#monthsCredit').on('input', function() {
                $('#monthsCreditValue').text($(this).val());
                getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());

                const monthsValue = $('#monthsCredit').val();

                if (pathName.includes('baic-3')) {
                    var priceGapTable = {
                        "24": "1220",
                        "36": "1220",
                        "48": "1680",
                        "60": "2170"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var priceGapTable = {
                        "24": "1500",
                        "36": "1500",
                        "48": "2015",
                        "60": "2480"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var priceGapTable = {
                        "24": "1860",
                        "36": "1860",
                        "48": "2560",
                        "60": "2900"
                    };
                }
                if (priceGapTable.hasOwnProperty(monthsValue)) {
                    $('#priceGapCredit').text(priceGapTable[monthsValue]);
                }

            });
            $('#downPaymentCredit').on('input', function() {
                $('#downPaymentCreditValue').text($(this).val() + '%');
                getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());
            });
            getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());
        }
    }

    /**
     * Pożyczka
     */
    function toCountLoan() {
        var pathName = window.location.pathname;
        if ($('#calculateRateLoan').hasClass('open')) {
            var result = $('#monthlyPaymentLoan');
            var rateResult = $('#monthlyRRSOLoan');


            if (pathName.includes('baic-7')) {
                var LoanTable = {

                    24: ["7 904 , 14,71", "7 510 , 14,72", "7 115 , 14,73", "6 721 , 14,75", "6 326 , 14,76", "5 932 , 14,78", "5 538 , 14,80"],
                    36: ["5 534 , 13,46", "5 258 , 13,47", "4 982 , 13,49", "4 706 , 13,50", "4 430 , 13,52", "4 154 , 13,53", "3 878 , 13,55"],
                    48: ["4 334 , 12,54", "4 118 , 12,55", "3 902 , 12,56", "3 686 , 12,58", "3 470 , 12,59", "3 254 , 12,61", "3 038 , 12,63"],
                    60: ["3 617 , 11,98", "3 437 , 11,99", "3 257 , 12,01", "3 077 , 12,02", "2 897 , 12,03", "2 717 , 12,05", "2 537 , 12,07"],
                    72: ["3 230 , 12,74", "3 069 , 12,75", "2 908 , 12,76", "2 748 , 12,78", "2 587 , 12,79", "2 426 , 12,81", "2 265 , 12,83"],
                    84: ["2 896 , 12,47", "2 752 , 12,48", "2 608 , 12,49", "2 464 , 12,51", "2 320 , 12,52", "2 176 , 12,54", "2 032 , 12,55"],
                    96: ["2 648 , 12,27", "2 516 , 12,28", "2 385 , 12,29", "2 253 , 12,30", "2 121 , 12,32", "1 990 , 12,33", "1 858 , 12,35"]
                };
            }
            if (pathName.includes('baic-5')) {
                var LoanTable = {
                    24: ["6 369 , 14,76", "6 051 , 14,77", "5 733 , 14,79", "5 416 , 14,81", "5 098 , 14,83", "4 780 , 14,85", "4 463 , 14,88"],
                    36: ["4 460 , 13,51", "4 237 , 13,53", "4 015 , 13,54", "3 793 , 13,56", "3 571 , 13,58", "3 348 , 13,60", "3 126 , 13,63"],
                    48: ["3 493 , 12,59", "3 319 , 12,60", "3 145 , 12,62", "2 971 , 12,63", "2 797 , 12,65", "2 624 , 12,68", "2 450 , 12,70"],
                    60: ["2 916 , 12,03", "2 771 , 12,05", "2 626 , 12,06", "2 481 , 12,08", "2 336 , 12,09", "2 191 , 12,12", "2 046 , 12,14"],
                    72: ["2 604 , 12,79", "2 475 , 12,80", "2 345 , 12,82", "2 216 , 12,83", "2 086 , 12,85", "1 957 , 12,87", "1 827 , 12,89"],
                    84: ["2 335 , 12,52", "2 219 , 12,53", "2 103 , 12,55", "1 987 , 12,56", "1 871 , 12,58", "1 755 , 12,60", "1 639 , 12,62"],
                    96: ["2 135 , 12,32", "2 029 , 12,33", "1 923 , 12,34", "1 817 , 12,36", "1 711 , 12,37", "1 605 , 12,39", "1 499 , 12,41"]
                };
            }
            if (pathName.includes('baic-3')) {
                var LoanTable = {
                    24: ["4 077 , 14,91", "3 874 , 14,93", "3 671 , 14,96", "3 468 , 14,99", "3 265 , 15,02", "3 061 , 15,05", "2 858 , 15,09"],
                    36: ["2 856 , 13,66", "2 714 , 13,68", "2 572 , 13,71", "2 430 , 13,74", "2 288 , 13,77", "2 146 , 13,80", "2 004 , 13,84"],
                    48: ["2 239 , 12,73", "2 127 , 12,76", "2 016 , 12,78", "1 905 , 12,80", "1 794 , 12,83", "1 683 , 12,87", "1 571 , 12,91"],
                    60: ["1 870 , 12,17", "1 777 , 12,19", "1 684 , 12,22", "1 592 , 12,24", "1 499 , 12,27", "1 406 , 12,30", "1 313 , 12,34"],
                    72: ["1 670 , 12,93", "1 587 , 12,95", "1 505 , 12,97", "1 422 , 12,99", "1 339 , 13,02", "1 256 , 13,05", "1 174 , 13,09"],
                    84: ["1 498 , 12,65", "1 424 , 12,67", "1 350 , 12,69", "1 276 , 12,72", "1 202 , 12,74", "1 127 , 12,77", "1 053 , 12,81"],
                    96: ["1 371 , 12,45", "1 303 , 12,46", "1 235 , 12,48", "1 167 , 12,51", "1 099 , 12,53", "1 032 , 12,56", "964 , 12,60"]
                };
            }

            $('#monthsLoan').on('input', function() {
                $('#monthsLoanValue').text($(this).val());
                getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());

                const monthsValue = $('#monthsLoan').val();

                if (pathName.includes('baic-3')) {
                    var priceGapTable = {
                        "24": "1220",
                        "36": "1220",
                        "48": "1680",
                        "60": "2170",
                        "72": "nie dotyczy",
                        "84": "nie dotyczy",
                        "96": "nie dotyczy"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var priceGapTable = {
                        "24": "1500",
                        "36": "1500",
                        "48": "2015",
                        "60": "2480",
                        "72": "nie dotyczy",
                        "84": "nie dotyczy",
                        "96": "nie dotyczy"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var priceGapTable = {
                        "24": "1860",
                        "36": "1860",
                        "48": "2560",
                        "60": "2900",
                        "72": "nie dotyczy",
                        "84": "nie dotyczy",
                        "96": "nie dotyczy"
                    };
                }
                if (priceGapTable.hasOwnProperty(monthsValue)) {
                    $('#priceGapLoan').text(priceGapTable[monthsValue]);
                }


            });
            $('#downPaymentLoan').on('input', function() {
                $('#downPaymentLoanValue').text($(this).val() + '%');
                getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());
            });
            getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());
        }
    }

});
